import { defineComponent as b, ref as p, provide as i, computed as l, createElementBlock as x, openBlock as w, normalizeClass as o, createElementVNode as s, renderSlot as h, normalizeStyle as T, unref as _ } from "vue";
import { usePositionedStyle as y } from "../../composables/usePositionedStyle.js";
import { tw as e } from "../../utils/tailwind.js";
import { setActiveTabKey as C, variantKey as N } from "./Tabs.constant.js";
const S = ["aria-label"], A = 4, W = /* @__PURE__ */ b({
  name: "RevTabs",
  __name: "Tabs",
  props: {
    label: {},
    variant: { default: "fixed" }
  },
  setup(n) {
    const a = n, f = {
      left: "0px",
      width: "0px"
    }, r = p(), { style: d } = y({
      callback: (t) => ({
        left: `${t.offsetLeft - A}px`,
        width: `${t.offsetWidth}px`
      }),
      defaultStyle: f,
      elementRef: r
    });
    i(C, (t) => {
      t && (r.value = t);
    }), i(N, a.variant);
    const c = l(() => [
      e`relative -mx-4 px-4`,
      a.variant === "flexible" && e`max-w-full overflow-x-auto`
    ]), m = l(() => [
      e`-mx-4 flex max-w-full list-none px-4`,
      a.variant === "fixed" && e`w-full overflow-x-hidden`,
      a.variant === "flexible" && e`gap-32`
    ]), u = l(() => [
      a.variant === "fixed" && e`max-w-full`,
      a.variant === "flexible" && e`w-max after:border-static-default-low after:absolute after:inset-x-4 after:bottom-8 after:-mt-1 after:border-t after:content-['']`
    ]), v = l(() => [
      e`border-static-default-low relative h-2 max-w-full border-b`,
      a.variant === "flexible" && e`mb-8`
    ]);
    return (t, L) => (w(), x("nav", {
      "aria-label": t.label,
      class: o(c.value)
    }, [
      s("div", {
        class: o(u.value)
      }, [
        s("ul", {
          class: o(m.value)
        }, [
          h(t.$slots, "default")
        ], 2),
        s("div", {
          "aria-hidden": "",
          class: o(v.value)
        }, [
          s("div", {
            class: "border-action-default-low-pressed absolute left-0 top-0 z-10 border-t-2 ease-in-out motion-safe:transition-all motion-safe:duration-200",
            style: T(_(d))
          }, null, 4)
        ], 2)
      ], 2)
    ], 10, S));
  }
});
export {
  W as default
};
